import myApi from '@/util/api'

export function getTaskMasters(id) {

    return myApi.getByID(id, 'TaskMaster/GetTaskMasters')
}
export function getTaskMastersbyID(id) {

    return myApi.getByID(id, 'TaskMaster/GetTaskMastersbyID')
}
export function getSubTasks() {

    return myApi.getAll('TaskMaster/GetSubTasks')
}
export function getSubTasksId(id, userId) {

    return myApi.getByuserId(id, userId, 'TaskMaster/GetSubTasksId')
}
export function getTaskTreeId(id, userId) {

    return myApi.getByuserId(id, userId, 'TaskMaster/GetSubNestedTasksId')
}
export function getuserTaskTreeId(id, userId) {

    return myApi.getByuserId(id, userId, 'TaskMaster/GetSubNestedUserTasks')
}
export function getApplicationUsers() {

    return myApi.getAll('ApplicationUser/GetApplicationUsers')
}
export function getUsers(data) {

    return myApi.getItem(data, 'ApplicationUser/GetUsers')
}
export function getUserById(id) {

    return myApi.getByID(id, 'ApplicationUser/GetUsersById')
}
export function getProjects() {

    return myApi.getAll('Project/GetProjects')
}
export function getTagMaster() {

    return myApi.getAll('TagMaster/GetTagMaster')
}

export function getTaskMaster(data) {

    return myApi.getItem(data, "TaskMaster/GetData")
}
export function getDataSubTask(data) {

    return myApi.getItem(data, "TaskMaster/GetDataSubTask")
}
export function createTaskMaster(data) {

    return myApi.create(data, "TaskMaster/InsertTaskMaster")
}

export function updateTaskMaster(data) {
    console.log(data);
    return myApi.update(data.taskID, data, "TaskMaster/UpdateTaskMaster")
}
export function createTaskNotes(data) {
    return myApi.create(data, "TaskNotes/InsertTaskNotes")
}
export function createPersonalTags(data) {
    return myApi.create(data, "PersonalTags/InsertPersonalTags")
}
export function updateTaskNotes(data) {

    return myApi.update(data, data, "TaskNotes/UpdateTaskNotes")
}
export function createSubTaskMaster(data) {
    console.log(data);
    return myApi.create(data, "TaskMaster/InsertSubTaskMaster")
}

export function updateSubTaskMaster(data) {
    console.log(data);
    return myApi.update(data.taskID, data, "TaskMaster/UpdateSubTaskMaster")
}
export function deleteTaskMaster(data) {

    return myApi.delete(data.taskID, 'TaskMaster/DeleteTaskMaster')
}

export function getTaskLinks() {

    return myApi.getAll('TaskMaster/GetTaskLinks')
}
export function getDataTaskLink(data) {

    return myApi.getItem(data, "TaskMaster/GetDataTaskLink")
}
export function createTaskLinks(data) {
    return myApi.create(data, "TaskMaster/InsertTaskLinks")
}

export function updateTaskLink(data) {

    return myApi.update(data.taskLinkID, data, "TaskMaster/UpdateTaskLink")
}
export function deleteTaskLink(data) {

    return myApi.delete(data.taskLinkID, 'TaskMaster/DeleteTaskLink')
}
export function getTaskAttachment(id) {

    return myApi.getByID(id, 'TaskAttachment/GetTaskAttachment')
}
export function getTaskComments(id) {

    return myApi.getByID(id, 'TaskComment/GetTaskComment')
}
export function createTaskComments(data) {

    return myApi.create(data, "TaskComment/InsertTaskComment")
}
export function updateTaskComment(data) {

    return myApi.update(data.taskCommentID, data, "TaskComment/UpdateTaskComment")
}
export function completeTask(data) {
    return myApi.update(data.taskID, data, "TaskMaster/CompleteTask")
}
export function closeTask(data) {
    return myApi.update(data.taskID, data, "TaskMaster/CloseTask")
}
export function getSubTasksbyStatus(id, userId) {

    return myApi.getByuserId(id, userId, 'TaskMaster/GetTaskByStatus')
}
export function getTaskAssigne(id, userId) {

    return myApi.getByuserId(id, userId, 'TaskMaster/GetTaskAsignee')
}
export function getPersonalTags(id, userId) {

    return myApi.getByuserId(id, userId, 'PersonalTags/GetPersonalTags')
}
export function getTaskNotes(id, userId) {

    return myApi.getByuserId(id, userId, 'TaskNotes/GetTaskNotes')
}
export function getTaskSearchFilter(data) {

    return myApi.getItem(data, "TaskMaster/GetTaskFilter")
}
export function getTaskSorting(id, userId) {

    return myApi.getByuserId(id, userId, 'TaskMaster/GetTaskSorting')
}
export function duplicateTask(data) {

    return myApi.update(data.userId, data, 'TaskMaster/DuplicateTask')
}

export function getTaskFiles(id) {

    return myApi.getByID(id, 'TaskMaster/GetTaskFiles')
}
export function getTeamMember(id) {

    return myApi.getByID(id, 'Project/GetTeamMember')
}
export function updateRead(id) {

    return myApi.getByID(id, 'TaskMaster/UpadateRead')
}
export function deleteTaskComment(data) {

    return myApi.delete(data.taskCommentID, 'TaskComment/DeleteTaskComment')
}
export function getDocComment(id) {

    return myApi.getByID(id, 'TaskComment/GetDocComment')
}
export function getUserGroups() {

    return myApi.getAll('TaskMaster/GetUserGroups')
}
export function getTaskMeetingNote(data) {

    return myApi.getItem(data, 'TaskMeetingNote/GetTaskMeetingNote')
}
export function updateTaskMeetingNote(data) {

    return myApi.update(data.taskMeetingNoteID, data, 'TaskMeetingNote/UpdateTaskMeetingNote')
}
export function updatePersonalTags(data) {

    return myApi.update(data.personalTagID, data, 'PersonalTags/UpdateTaskMeetingNote')
}
export function createTaskMeetingNote(data) {

    return myApi.create(data, "TaskMeetingNote/InsertTaskMeetingNote")
}
export function getPersonalTagsByUser(id) {

    return myApi.getByID(id, 'PersonalTags/GetPersonalTagsByUser')
}


// WEBPACK FOOTER //
// ./src/api/taskMaster.js